import { gql } from '@apollo/client';

export const UPDATE_FAVORITE_AI_SOLUTIONS = gql`
  mutation ($v1: AiSolutionInputType!) {
    aiSolution {
      put(input: $v1) {
        id
      }
    }
  }
`;
